import UploadProgressBar from 'app/components/UploadProgressBar';

const BackgroundUploadProgressBar = props => {
  const {
    accessCodePage
  } = props;

  // this fileId matches the one in useAccessCodePageBackgroundUploadForm
  let fileId = accessCodePage.id + '-background';

  return <UploadProgressBar {...{ fileId }} />;
}

export default BackgroundUploadProgressBar;
